<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-09 15:11:17
 * @Description: 同步操作员至省平台
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50"
    title="同步结果查看"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-table
      ref="userResultTable"
      class="c-page__table o-header-text-center"
      height="100%"
      stripe
      border
      highlight-current-row
      tooltip-effect="dark"
      :data="userList"
      :class="{ 'o-table-empty-center': userList.length <= 0 }"
    >
      <el-table-column
        type="index"
        label="序号"
        width="40"
        align="center"
      />
      <el-table-column
        prop="userName"
        label="姓名"
        width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="tel"
        label="执行结果"
        width="120"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span :class="{'u-text-success': scope.row.status ==='Y', 'u-text-danger': scope.row.status !=='Y'}">
            {{ scope.row.status === 'Y'? '成功' : '失败' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="message"
        label="执行说明"
        min-width="150"
        show-overflow-tooltip
      />
    </el-table>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'OperatorViewDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading建筑类别
      dialogShow: true, // 模态框dialog显示

      userList: []

    };
  },
  computed: {
  },
  methods: {

    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.userList = this.dlParams.userList;
  }
};
</script>
